/*
 * @Description: 安全中心模块
 * @Author: Harry
 * @Date: 2020-12-28 13:48:01
 * @LastEditTime: 2020-12-29 15:11:34
 * @LastEditors: Harry
 */
import i18n from "@/locales";

export default [
  {
    //登录密码修改
    path: "/login-password-modify",
    name: "login-password-modify",
    component: () => import("@/views/security-center/PasswordLoginModify.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("security_center.login_password_modify.nav_title")
    }
  },
  {
    //交易密码修改
    path: "/trade-password-modify",
    name: "trade-password-modify",
    component: () => import("@/views/security-center/PasswordTradeModify.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("security_center.trade_password_modify.nav_title")
    }
  },
  {
    //交易密码重置
    path: "/trade-password-reset",
    name: "trade-password-reset",
    component: () =>
      import("@/views/security-center/PasswordTradeReset/index.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("security_center.trade_password_reset.nav_title")
    }
  },
  {
    // 登录设备管理
    path: "/login-device",
    name: "login-device",
    component: () => import("@/views/security-center/LoginDevice.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("security_center.login_device.nav_title")
    }
  }
];
